<div class="image-overlay">
  <i class="fal fa-times image-overlay-close pointer" (click)="close()"></i>
  <video class="video-overlay-thumbnail" *ngIf="video.url" autoplay controls="true">
    <source [src]="video.url" type="video/mp4">
  </video>
</div>
